// Styles for OffersHeroV2 go here.
import styled from 'styled-components';

export const StyledOffersHeroV2 = styled.div``;
